function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import Text from "./Text";
const TAG_MAP = {
  display2: "h1",
  display1: "h2",
  headline: "h3",
  headtitle: "h4",
  large: "h5",
  label: "h6"
};
/**
 * Headings give page and section tiles more prominence over body text.
 * See [Typography](/?path=/docs/typography--headings) for more examples.
 */

export default class Heading extends Component {
  render() {
    const {
      textSize,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(Text, _extends({
      space: "x2"
    }, rest, {
      Component: TAG_MAP[textSize],
      textSize: textSize
    }));
  }

}

_defineProperty(Heading, "defaultProps", {
  textSize: "large"
});